module.exports = __webpack_public_path__ + "img/icon_email-thin.745b5a9e.svg";